import React from 'react';
export const OpenCurrentUrlInBadatelna = () => (
  <>
    &nbsp;|&nbsp;
    <a
      href={`https://ais-ap4tst.is.cuni.cz${window.location.pathname}`}
      target="_blank"
      rel="noreferrer"
    >
      otvor v badatelni
    </a>
  </>
);
